import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import {Button, Form, Row} from "react-bootstrap";
import {useSearchParams} from "react-router-dom";
import {
    PRE_TOURNAMENT_SELECTION,
    STAGING_BASE_URL,
} from "../../Axios/EndPoints";
import GoldenTeamSelection from "./PreTournamentSelections/GoldenTeamSelection";
import GroupTopAndBottomTeams from "./PreTournamentSelections/GroupTopAndBottomTeams";
import ButtonLoader from "../ButtonLoader";
import {post} from "../../Axios/post";
import EuroInstructionModal from "./PreTournamentSelections/EuroInstructionModal";
import CustomModal from "../ModalComponent/CustomModal";

const EuroPreTournament = (props) => {
    const {
        isMobile,
        isLogin,
        user,
        leagueId,
        leagueTeams,
        leagueGroups,
        edit,
        setEdit,
        setUserTournamentSelection,
        mySelections,

    } = props;

    // console.log("edit >>>", edit)
    // console.log("mySelections on edit =>>>>>", mySelections)


    const [params] = useSearchParams();

    // console.log("user >>>", user?.token)
    const [showInstructionModal, setShowInstructionModal] = useState(true);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalStatus, setModalStatus] = useState("");
    // console.log("showInstructionModal >>>", showInstructionModal)

    // console.log("leagueGroups >>>>", leagueGroups)

    const [selectedGoldenTeam, setSelectedGoldenTeam] = useState(mySelections?.golden_team?.goalserve_id || "");
    // console.log("selectedGoldenTeam >>>", selectedGoldenTeam);
    const [groupPositions, setGroupPositions] = useState([]);
    // console.log("groupPositions >>>", groupPositions);
    const [tieBreak, setTieBreak] = useState(mySelections?.tie_breaker || "");
    const [submitLoading, setSubmitLoading] = useState(false);


    useEffect(() => {
        if (edit) {
            setShowInstructionModal(false);
        }
    }, [edit]);
    const handleTieBreakChange = (e) => {
        const value = e.target.value;
        // Ensure the value is a positive number or an empty string
        if (value === "" || (!isNaN(value) && parseFloat(value) > 0)) {
            setTieBreak(value);
        }
    };

    const submitTournamentSection = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        let isStaging = parseInt(params.get('staging'));

        let data = {
            golden_team_id: selectedGoldenTeam,
            tie_breaker: parseInt(tieBreak),
            league_id: leagueId,
            group_positions: groupPositions,
        }
        // console.log("data to submit >>>>>", data)
        post(PRE_TOURNAMENT_SELECTION, data, true, user?.token, null, isStaging ? STAGING_BASE_URL : '')
            .then((response) => {
                if (response?.data?.success) {
                    // console.log("response for pre tournament selection >>", response?.data);
                    setShowCustomModal(true);
                    setModalMessage(response?.data?.message);
                    if (edit === true) {
                        setEdit(false);
                    }
                }
            })
            .catch((error) => {
                console.error('Pre tournament selection error', error?.response);
                setShowCustomModal(true);
                setModalMessage("Please ensure you have selected the golden team, the top and bottom teams from each group, and provided a tie-break prediction (total number of goals in the tournament)");
                setModalStatus("error");
            })
            .finally(() => {
                setSubmitLoading(false);
            })
    }

    const onClickModal = () => {
        setShowCustomModal(false);
        if(modalStatus === "error"){
            // setUserTournamentSelection(false)
        }else{
            setUserTournamentSelection(true);
        }
        setModalMessage("");
        setModalStatus("");
    }

    const renderMobile = () => {
        return (
            <>
                {
                    edit ?
                        <></>
                        :
                        <>
                            <div
                                className={`text-center fw-bold font-60 h1 gibson text-uppercase ${edit ? "text-skins-blue" : "text-white"}`}>
                                <span className={'font-50'}>Euro</span> {' '}
                                <span className={'text-skins-teal font-45'}>2024</span>
                            </div>
                            <div
                                className={`text-center fw-bold font-24 cabin mb-3 text-uppercase ${edit ? "text-skins-blue" : "text-white"}`}>
                                Welcome Back!
                            </div>
                        </>
                }

                <Container className={"pb-5"}>
                    {/*<div className={"skins-red-horizontal-line"}></div>*/}
                    {/*<div className={"py-4"}>*/}
                    {/*    <EuroInstructions*/}
                    {/*        isMobile={isMobile}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    {
                        edit ?
                            <></>
                            :
                            <>
                                <div className={"skins-red-horizontal-line"}></div>
                            </>
                    }
                    {
                        leagueTeams &&
                        <>
                            <div className={`${edit ? "" : "py-2"}`}>
                                <GoldenTeamSelection
                                    isMobile={isMobile}
                                    leagueTeams={leagueTeams}
                                    selectedGoldenTeam={selectedGoldenTeam}
                                    setSelectedGoldenTeam={setSelectedGoldenTeam}
                                    edit={edit}
                                    myGoldenTeam={mySelections?.golden_team}
                                />
                            </div>
                        </>
                    }
                    {
                        leagueGroups &&
                        <>
                            <div className={"py-2"}>
                                <GroupTopAndBottomTeams
                                    isMobile={isMobile}
                                    leagueGroups={leagueGroups}
                                    groupPositions={groupPositions}
                                    setGroupPositions={setGroupPositions}
                                    edit={edit}
                                    myGroupPositions={mySelections?.group_positions}
                                />
                            </div>
                        </>
                    }
                    <div className={"w-100 d-flex align-items-center justify-content-center"}>
                        <Form.Control
                            className={"w-100 input-form-control-gold"}
                            type="text"
                            placeholder="Tie Break (Total goals in tournament)"
                            value={tieBreak}
                            // onChange={(e) => setTieBreak(e.target.value)}
                            onChange={handleTieBreakChange}
                        />
                    </div>
                    <div className={"w-100 d-flex align-items-center justify-content-center mt-4"}>
                        <Button
                            className={'btn-skins-red w-100'}
                            type={'button'}
                            size={'lg'}
                            onClick={(e) => {
                                submitTournamentSection(e)
                            }}
                        >
                            {submitLoading ? <>
                                <ButtonLoader loading={submitLoading}/>
                            </> : <>
                                Submit
                            </>}

                        </Button>
                    </div>
                    {
                        edit &&
                        <div className={"w-100 d-flex align-items-center justify-content-center mt-2"}>
                            <Button
                                className={'bg-dark-blue border-medium-white w-100'}
                                type={'button'}
                                size={'lg'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setEdit(false)
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    }
                </Container>

            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <Row>
                    <div className={'text-center fw-bold font-60 h1 text-white gibson text-uppercase'}>
                        <span className={''}>Euro</span> {' '}
                        <span className={'text-skins-teal'}>2024</span>
                    </div>
                </Row>
                <div className={'text-center fw-bold font-24 text-white cabin mb-5 text-uppercase'}>
                    Welcome Back!
                </div>
                <Container className={"pb-5"}>
                    {/*<div className={"skins-red-horizontal-line"}></div>*/}
                    {/*<div className={"py-4"}>*/}
                    {/*    <EuroInstructions*/}
                    {/*        isMobile={isMobile}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <div className={"skins-red-horizontal-line"}></div>
                    {
                        leagueTeams &&
                        <>
                            <div className={"py-4"}>
                                <GoldenTeamSelection
                                    isMobile={isMobile}
                                    leagueTeams={leagueTeams}
                                    selectedGoldenTeam={selectedGoldenTeam}
                                    setSelectedGoldenTeam={setSelectedGoldenTeam}
                                    edit={edit}
                                    myGoldenTeam={mySelections?.golden_team}

                                />
                            </div>
                        </>
                    }

                    {
                        leagueGroups &&
                        <>
                            <div className={"py-4"}>
                                <GroupTopAndBottomTeams
                                    isMobile={isMobile}
                                    leagueGroups={leagueGroups}
                                    groupPositions={groupPositions}
                                    setGroupPositions={setGroupPositions}
                                    edit={edit}
                                    myGroupPositions={mySelections?.group_positions}
                                />
                            </div>
                        </>
                    }
                    <div className={"w-100 d-flex align-items-center justify-content-center"}>
                        <Form.Control
                            className={"w-50 input-form-control-yellow"}
                            type="text"
                            placeholder="Tie Break (Total number of goals in tournament)"
                            value={tieBreak}
                            // onChange={(e) => setTieBreak(e.target.value)}
                            onChange={handleTieBreakChange}
                        />
                    </div>
                    <div className={"w-100 d-flex align-items-center justify-content-center mt-5"}>
                        <Button
                            className={'btn-skins-red w-50'}
                            type={'button'}
                            size={'lg'}
                            onClick={(e) => {
                                submitTournamentSection(e)
                            }}
                        >
                            {submitLoading ? <>
                                <ButtonLoader loading={submitLoading}/>
                            </> : <>
                                Submit
                            </>}

                        </Button>
                    </div>
                    {
                        edit &&
                        <div className={"w-100 d-flex align-items-center justify-content-center mt-2"}>
                            <Button
                                className={'bg-transparent border-medium-white w-50'}
                                type={'button'}
                                size={'lg'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setEdit(false)
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    }


                </Container>

            </>
        );
    }
    const render = () => {
        return (
            <section
            >
                {
                    showInstructionModal && isLogin && !edit &&
                    <EuroInstructionModal
                        showModal={showInstructionModal}
                        setShowModal={setShowInstructionModal}
                        isMobile={isMobile}
                    />
                }
                {
                    showCustomModal &&
                    <CustomModal
                        showModal={showCustomModal}
                        setShowModal={setShowCustomModal}
                        message={modalMessage}
                        modalStatus={modalStatus}
                        onClick={onClickModal}
                    />
                }
                {
                    !showInstructionModal && isLogin &&
                    <>
                        {isMobile ? renderMobile() : renderDesktop()}
                    </>
                }

            </section>
        );
    }

    return render();
}

export default EuroPreTournament;
